import clsx from 'clsx';
import React from 'react';

import { ConfidenceLevelProps, FILL_STAGGER_MS, MAX_CONFIDENCE_LEVEL } from './interface';

const ConfidenceLevel = ({ animate = true, className, confidenceLevel }: ConfidenceLevelProps) => {
  return (
    <div
      aria-label={`Confidence level ${confidenceLevel} of ${MAX_CONFIDENCE_LEVEL}`}
      className={clsx('flex w-[87px] gap-4', className)}
      role="meter"
      aria-valuenow={confidenceLevel}
      aria-valuemin={1}
      aria-valuemax={MAX_CONFIDENCE_LEVEL}
    >
      {Array.from({ length: MAX_CONFIDENCE_LEVEL }, (_, index) => {
        const isFilled = index < confidenceLevel;

        return (
          <span
            className="relative box-border h-12 flex-1 overflow-hidden border border-solid border-primary-magenta"
            data-testid={isFilled ? 'confidence-level-bar-filled' : 'confidence-level-bar'}
            key={index}
          >
            {isFilled && (
              <span
                aria-hidden="true"
                className={clsx(
                  'absolute inset-0 origin-left bg-primary-magenta motion-reduce:scale-x-100 motion-reduce:transition-none',
                  'transition-transform duration-500 ease-out',
                  animate ? 'scale-x-100' : 'scale-x-0'
                )}
                data-testid="confidence-level-bar-fill"
                style={{ transitionDelay: animate ? `${index * FILL_STAGGER_MS}ms` : '0ms' }}
              />
            )}
          </span>
        );
      })}
    </div>
  );
};

export default ConfidenceLevel;
